export const MULTI_ACT_UPDATE_EXTRACTED_NAMS = 'MULTI_ACT_UPDATE_EXTRACTED_NAMS';
export const MULTI_ACT_ADD_NAMS = 'MULTI_ACT_ADD_NAMS';
export const MULTI_ACT_UPDATE_NAMS = 'MULTI_ACT_UPDATE_NAMS';
export const MULTI_ACT_INITIATE_NAM_OCR = 'MULTI_ACT_INITIATE_NAM_OCR';
